import { Container } from 'pixi.js';
import { createPixiText } from '../../Utils/Utils';
import { gameConfig } from '../../index';
import Core from '../../Core/Core';

export class LoadingTxt extends Container {
    private txt: PIXI.Text;
    constructor() {
        super();

        this.txt = createPixiText(
            Core.local.getText('loading') + '...',
            new PIXI.Rectangle(0, 0, gameConfig.game_width * 0.7, gameConfig.game_height * 0.2),
            'Baloo',
            50,
            50,
            0xffffff
        );

        this.addChild(this.txt);
    }

    public update(str: string) {
        this.txt.text = str;
    }
}
